import Ajax from '../util/ajax';
export function fetchZigbeeAttributeReporting(nid, eid, cid, dir, aid) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/' + cid + '/' + dir + '/attribute/' + aid + '/reporting';
        ajax.get(url);
    };
}
